// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const SocialDeviantArtIcon = (props?: any) => <Icon {...props} dangerouslySetIcon={'<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17.55 2h-3.225l-.45.5L12.3 5.75l-.3.417H6V11h3.525l.15.333-3.225 7V22h3.225l.45-.5 1.5-3.25.375-.417h6V13h-3.45l-.3-.25 3.3-7.083V2z" fill="currentColor"/></svg>'} />;

(SocialDeviantArtIcon as any).displayName = 'SocialDeviantArtIcon';

export default SocialDeviantArtIcon;
